import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import Seo from '../components/common/Seo';
import PageHero from '../components/common/PageHero';
import { solutions } from '@/data/solutions';
import { seo } from '@/data/seo';
import { getIcon } from '@/components/common/iconMap';

const Solutions = () => {
  return (
    <div className="min-h-screen bg-white pt-20">
      <Seo {...seo.solutions} />
      <PageHero
        eyebrow="Our solutions"
        title="IT, telecom, military,"
        highlight="and manpower"
        description="Planned and implemented through MAYAN’s own resources and through specialised partners."
      />

      <section className="py-20 relative bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          {solutions.map((solution) => {
            const Icon = getIcon(solution.icon);
            return (
              <motion.article
                key={solution.slug}
                id={solution.slug}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                className="bg-white border border-gray-200 rounded-2xl p-8 md:p-12 hover:border-[#398024] hover:shadow-xl transition-all duration-300"
              >
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                  <div>
                    <div className="w-16 h-16 bg-[#398024] rounded-xl flex items-center justify-center mb-6">
                      <Icon className="text-white" size={32} />
                    </div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-4">{solution.title}</h2>
                    <p className="text-gray-600 leading-relaxed">{solution.description}</p>
                  </div>
                  <div className="lg:col-span-2">
                    <h3 className="text-sm font-semibold text-[#398024] uppercase tracking-wider mb-4">Scope</h3>
                    <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      {solution.items.map((item) => (
                        <li key={item} className="flex items-start space-x-3 bg-gray-50 rounded-xl p-4">
                          <div className="w-5 h-5 bg-[#398024]/10 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                            <div className="w-1.5 h-1.5 bg-[#398024] rounded-full" />
                          </div>
                          <span className="text-gray-700 text-sm leading-relaxed">{item}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </motion.article>
            );
          })}
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">Looking for industrial supply instead?</h3>
          <p className="text-gray-600 mb-8">
            Equipment, laboratory, energy, and meteorological work is listed under Services.
          </p>
          <Link
            to="/services"
            className="inline-block bg-[#398024] text-white px-8 py-4 rounded-lg font-semibold hover:bg-[#2d6b1a] transition-all duration-300"
          >
            View services
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Solutions;
